<script setup lang="ts">

  const props = defineProps({
    modelValue: {
      type: Object as PropType<any[]>,
    },
    label: {
      type: String,
      default: null,
    },
    options: {
      type: Array as PropType<any[]>,
      default: []
    },
    selectOptionsKey: {
      type: String,
      default: 'id',
    },
    selectOptionsLabel: {
      type: String,
      default: 'name',
    },
    placeholder: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    hint: {
      type: [String, Array] as PropType<string | string[]>,
      default: undefined,
    },
    invalid: {
      type: Boolean,
      default: false,
    },
    selectPlacement: {
      type: String,
      default: 'bottom-start',
    },
  })

  const inputOptions = computed(() => {
    const {modelValue, ...bindOptions} = props;
    return bindOptions;
  });


  const filteredOptions = computed(() => {
      return props.options.filter((option: any) => {
        return Array.isArray(props.modelValue) ? !props.modelValue.some((selected) => {
          return selected[props.selectOptionsKey] === option[props.selectOptionsKey]
        }) : true;
      });
  })

  const emit = defineEmits(['update:modelValue']);
  const onSelectOption = (option) => {
    emit('update:modelValue', [...props.modelValue, option]);
  }
  const removeChip = (chip) => {
    emit('update:modelValue', props.modelValue.filter(option => option[props.selectOptionsKey] !== chip[props.selectOptionsKey]));
  }
</script>

<template>
  <div class="wad4-select-chips">
    <FormInputField type="select" v-bind="inputOptions" :selectOptions="filteredOptions" @update:modelValue="onSelectOption" />
    <div class="wad4-select-chips__chips">
      <div v-for="chip in props.modelValue" class="wad4-select-chips__chip">
        {{chip[props.selectOptionsLabel]}}
        <svg class="wad4-select-chips__chip-remove" @click="removeChip(chip)" xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
          <path d="M11.5751 8.09115L10.0001 9.66615L8.42508 8.09115C8.10008 7.76615 7.57508 7.76615 7.25008 8.09115C6.92508 8.41615 6.92508 8.94115 7.25008 9.26615L8.82508 10.8411L7.25008 12.4161C6.92508 12.7411 6.92508 13.2661 7.25008 13.5911C7.57508 13.9161 8.10008 13.9161 8.42508 13.5911L10.0001 12.0161L11.5751 13.5911C11.9001 13.9161 12.4251 13.9161 12.7501 13.5911C13.0751 13.2661 13.0751 12.7411 12.7501 12.4161L11.1751 10.8411L12.7501 9.26615C13.0751 8.94115 13.0751 8.41615 12.7501 8.09115C12.4251 7.77448 11.8917 7.77448 11.5751 8.09115ZM10.0001 2.50781C5.39175 2.50781 1.66675 6.23281 1.66675 10.8411C1.66675 15.4495 5.39175 19.1745 10.0001 19.1745C14.6084 19.1745 18.3334 15.4495 18.3334 10.8411C18.3334 6.23281 14.6084 2.50781 10.0001 2.50781ZM10.0001 17.5078C6.32508 17.5078 3.33341 14.5161 3.33341 10.8411C3.33341 7.16615 6.32508 4.17448 10.0001 4.17448C13.6751 4.17448 16.6667 7.16615 16.6667 10.8411C16.6667 14.5161 13.6751 17.5078 10.0001 17.5078Z" fill="currentColor"/>
        </svg>
      </div>
    </div>
  </div>

</template>

<style lang="scss">
  .wad4-select-chips {
    display: flex;
    flex-direction: column;
    gap: $wad4-spacing-md;

    &__chips {
      display: flex;
      gap: $wad4-spacing-md;
      flex-wrap: wrap;
    }

    &__chip {
      display: flex;
      gap: 3px;
      align-items: center;
      padding: 0 $wad4-spacing-lg;
      height: 32px;
      border-radius: 16px;
      background: $wad4-chip-skill;
      color: $wad4-chip-onSkill;
      @include text-size-mixin('sm');

      &-remove {
        cursor: pointer;
      }
    }

  }
</style>
